/**
 * Hide/show password text in form
 * @module password-toggle
 * @author Vincent Falconi <vfalconi@sumologic.com>
 */

const handler = (event) => {
	event.preventDefault();
	const fieldName = event.target.closest('button').dataset.inputToggle;
	const toggledField = document.querySelector(`input[name="${fieldName}"]`);
	const toggledFieldState = (toggledField.type === 'password');
	if (toggledFieldState === true) {
		toggledField.type = 'text';
	} else {
		toggledField.type = 'password';
	}
}

export default () => {
	const passwordToggle = document.querySelectorAll('button[data-input-toggle]');

	passwordToggle.forEach((el) => {
		el.addEventListener('click', handler);
	});
};
